import { CommonModule } from '@angular/common';
import { Component, HostBinding, Input } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

export type ModalShellSize = 'sm' | 'md' | 'lg';
export type ModalShellLayout = 'form' | 'confirm' | 'dense' | 'summary';
export type ModalShellTone = 'default' | 'danger';

export interface ModalShellConfig {
  title: string;
  subtitle?: string | null;
  size?: ModalShellSize;
  layout?: ModalShellLayout;
  tone?: ModalShellTone;
}

@Component({
  selector: 'app-modal-shell',
  standalone: true,
  imports: [CommonModule, MatDialogModule],
  templateUrl: './modal-shell.component.html',
  styleUrl: './modal-shell.component.scss',
})
export class ModalShellComponent {
  @Input({ required: true }) config!: ModalShellConfig;

  @HostBinding('class')
  get hostClasses(): string {
    return [
      'modal-shell',
      `modal-shell--${this.size}`,
      `modal-shell--${this.layout}`,
      `modal-shell--${this.tone}`,
    ].join(' ');
  }

  get size(): ModalShellSize {
    return this.config?.size ?? 'md';
  }

  get layout(): ModalShellLayout {
    return this.config?.layout ?? 'form';
  }

  get tone(): ModalShellTone {
    return this.config?.tone ?? 'default';
  }
}
